var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"blue lighten-5"},[_c('v-card-title',[_vm._v("Profile of user")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }